import { PromptPreviewObject } from "../../../../../interfaces";
import { PromptServices, PromptStatsResponse, SmartLinkServices } from "../../../../../services/bedrock";
import { useEffect } from "react";
import * as React from "react";

import PostsStats from "../../../../../components/PostsStats";
import { SmartLinkAggregatedStatsDialog } from "@/containers/Coach/SmartLink/StatsDialog/SmartLinkAggregatedStatsDialog";

interface PromptStatsProps {
  prompt: PromptPreviewObject | undefined;
}

type Props = PromptStatsProps;

const PromptStats: React.FC<Props> = ({ prompt }) => {
  const [stats, setStats] = React.useState<PromptStatsResponse>();
  const [loading, setLoading] = React.useState<boolean>(false);

  const [totalClicks, setTotalClicks] = React.useState<number>();
  const [loadingClickStats, setLoadingClickStats] = React.useState<boolean>(false);
  const [showSmartLinkStats, setShowSmartLinkStats] = React.useState<boolean>(false);

  const requestStats = async () => {
    const promptId = prompt?.promptId;
    if (promptId) {
      setLoading(true);
      const stats = await PromptServices.getPromptStats(promptId);
      setStats(stats);
    }
    setLoading(false);
  };

  const requestClickStats = async () => {
    const smartLinkId = prompt?.smartLinkId;
    if (smartLinkId && prompt.promptId) {
      setLoadingClickStats(true);
      const data = await SmartLinkServices.getSmartLinkStatsByPrompt(prompt.promptId, ["total_clicks"]);
      setTotalClicks(data.totalClicks || 0);
    }
  };

  useEffect(() => {
    requestStats().catch(console.error);
    requestClickStats().catch(console.error);
  }, [prompt]);

  return prompt ? (
    <>
      <PostsStats
        stats={stats}
        smartLinkClicks={totalClicks}
        showSmartLinkStats={() => setShowSmartLinkStats(true)}
        type={"Prompt"}
        loading={loading}
      />
      {prompt.deliveryMode === "DYNAMIC" && (
        <p className="mt-3 text-xs text-slate-500">
          Counts every post made from this design, including posts a coach made for a player.
        </p>
      )}

      {showSmartLinkStats && (
        <SmartLinkAggregatedStatsDialog
          open={showSmartLinkStats}
          onOpenChange={setShowSmartLinkStats}
          type={"Prompt"}
          entity={prompt}
        />
      )}
    </>
  ) : undefined;
};

export default PromptStats;
